<template>
  <div class="bm-verify">
    <div class="notice">请认证个人信息，获取保单</div>
    <cube-form
      :model="model"
      :schema="smsSchema"
      :immediate-validate="false"
      :options="options"
      @validate="validateHandler"
      @submit="submitSmsHandler">
      <cube-form-item :field="smsSchema.fields[0]"></cube-form-item>
      <cube-form-item :field="smsSchema.fields[1]">
        <cube-select v-model="model.certTypeName" :options="certTypeList"></cube-select>
      </cube-form-item>
      <cube-form-item :field="smsSchema.fields[2]"></cube-form-item>
      <!-- <cube-form-item :field="smsSchema.fields[3]">
      </cube-form-item> -->
      <div class="space"></div>
      <cube-form-item class="verify" :field="smsSchema.fields[3]"></cube-form-item>
      <cube-form-item class="verify" :field="smsSchema.fields[4]">
        <cube-input class="sms-code" v-model="model.smsCode" placeholder="请输入验证码"></cube-input>
        <cube-button class="send-code" :class="{active: !!timer}" :inline="true" @click="sendSmsCode()">{{sendCodeLabel}}</cube-button>
      </cube-form-item>
      <cube-form-item class="verify-submit" :class="{active: isValid}" :field="smsSchema.fields[5]"></cube-form-item>
      </cube-form>
      <div class="agree">确定即代表阅读并同意<span class="agree-link" @click="$refs.extendPopup.show()">《斑马邦用户协议》</span></div>
      <cube-extend-popup center="false" ref="extendPopup"></cube-extend-popup>
  </div>
</template>

<script>
import { sendSmsCode } from '@/api/user'
import CubeExtendPopup from '@/components/CubeExtendPopup'
import map from 'lodash/map'
import find from 'lodash/find'
import { getUserInfo } from '@/libs/cookie-storage'

const TIME_COUNT = 50
const beforeSend = '获取验证码'
const afterSend = 's后重新获取'
const CERT_LIST = [
  {id: 1, label: '身份证'},
  {id: 2, label: '护照'},
  {id: 3, label: '出生证'},
  {id: 4, label: '驾照'},
  {id: 5, label: '港澳通行证'},
  {id: 6, label: '军官证'},
  {id: 7, label: '台胞证'},
  {id: 8, label: '警官证'},
  {id: 9, label: '港澳台回乡证'},
  {id: 10, label: '组织机构代码证'},
  {id: 11, label: '营业执照'},
  {id: 12, label: '税务登记号'},
  {id: 13, label: '三证合一'},
  {id: 14, label: '统一信用代码证'},
  {id: 99, label: '其他'}
]
export default {
  name: 'Login',
  components: {CubeExtendPopup},
  data() {
    return {
      count: TIME_COUNT,
      timer: null,
      show: true,
      validity: {},
      valid: undefined,
      certTypeList: map(CERT_LIST, 'label'),
      model: {
        realName: '',
        certTypeName: CERT_LIST[0].label,
        certNumber: '',
        // gender: CERT_LIST[0].label,
        userName: '' // 11001765001
        // smsCode: '1234'
      },
      sendCodeLabel: beforeSend,
      smsSchema: {
        fields: [
          {
            type: 'input',
            modelKey: 'realName',
            label: '真实姓名',
            props: {
              placeholder: '请输入真实姓名'
            },
            rules: {
              required: true // ^[\u4e00-\u9fa5]{2,4}$
            }
          },
          {
            type: 'input',
            modelKey: 'certTypeName',
            label: '证件类型',
            props: {
              placeholder: '请输入证件类型'
            }
          },
          {
            type: 'input',
            modelKey: 'certNumber',
            label: '证件号码',
            props: {
              placeholder: '请输入证件号码'
            },
            rules: {
              required: true // /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
            }
          },
          // {
          //   type: 'input',
          //   modelKey: 'gender',
          //   label: '性别'
          // },
          {
            type: 'input',
            modelKey: 'userName',
            props: {
              placeholder: '手机号码（斑马邦用户请使用注册手机号码）'
            },
            rules: {
              required: true,
              pattern: /^1\d{10}$/
            }
          },
          {
            modelKey: 'smsCode',
            rules: {
              required: true
            }
          },
          {
            type: 'submit',
            label: '完 成'
          }
        ]
      },
      options: {
        scrollToInvalidField: true
      }
    }
  },
  created () {
    const user = getUserInfo()
    if (user && user.mobile) {
      this.model.userName = user.mobile
      this.smsSchema.fields[3].props.readonly = 'readonly'
    } else {
      this.smsSchema.fields[3].props.readonly = null
    }
  },
  computed: {
    isValid: function () {
      return this.validity.realName && this.validity.realName.valid && this.validity.certNumber.valid && this.validity.smsCode.valid
    }
  },
  methods: {
    submitSmsHandler(e) {
      e.preventDefault()
      const self = this
      const certType = find(CERT_LIST, function(o) {
        return o.label === self.model.certTypeName
      })
      this.model.certType = certType.id
      this.$store.dispatch('SmsLogin', this.model).then(() => {
        this.$router.push({ path: '/insure-list' })
      }).catch(() => {
      })
    },
    sendSmsCode() {
      if (this.timer) return
      this.sendCodeLabel = this.count + afterSend
      sendSmsCode(this.model.userName).then(
        response => {
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--
              this.sendCodeLabel = this.count + afterSend
            } else {
              this.show = true
              clearInterval(this.timer)
              this.timer = null
              this.sendCodeLabel = beforeSend
              this.count = TIME_COUNT
            }
          }, 1000)
        }
      )
    },
    validateHandler(result) {
      this.validity = result.validity
      // this.valid = result.valid
      console.log('validity', result.validity, result.valid, result.dirty, result.firstInvalidFieldIndex)
    }
  }
}

</script>

<style lang="stylus">
.bm-verify
  .cube-form-item_required
    .cube-form-label::before
      content ''
      margin 0
  .cube-form_standard
    .verify
      .cube-input
        input
          text-align left
          background-color #f2f2f2
          font-size 32px; /*px*/
          color #9b9b9b
          border-radius 0
          height 92px
          line-height 92px
          padding-left 20px
      &.cube-form-item
        padding-top 30px
      &.border-bottom-1px::after
        border none
    .cube-select
      text-align right
    .cube-input
      input
        text-align right
      &.sms-code
        float left
        width 55%
        padding-bottom 30px
  .cube-btn
    &.send-code
      width: 45%;
      padding: 0 16px;
      background-color #ec4e4e
      font-size 32px; /*px*/
      border-radius 0
      height 92px;
      line-height 92px
      &.active
        background-color #9b9b9b

.bm-verify
  .notice
    text-align center
    font-size 36px; /*px*/
    color: #9b9b9b
    padding 32px 0
    background-color #ffffff
    margin-bottom 30px
  .space
    height 30px
    background-color #f2f2f2
  .verify-submit
    text-align center
    background: #f2f2f2;
    padding-top: 80px;
    &.cube-form-item_btn
      margin 0
    &.active
      .cube-btn
        color #ec4e4e
        border 1px solid #ec4e4e; /*no*/
    .cube-btn
      border-radius 46px
      border 1px solid #9b9b9b; /*no*/
      width: 286px;
      background: #fff;
      color: #9b9b9b;
      text-align: center;
      padding: 30px 16px;
      position: absolute;
      left: 50%;
      margin-left: -143px;
      &:active::after
        border-radius 120px; /*px*/
  .agree
    color: #3b3b3b
    font-size 24px; /*px*/
    text-align center
    padding-top 60px
    .agree-link
      color #3878de
  .cube-popup
    position fixed

.verify
  .cube-validator_invalid
    .cube-validator-msg
      display none
    .cube-input
      input
        border: 1px solid red

.bm-verify
  .cube-popup-content
    width 100%
    height 100%
    overflow auto
</style>



// WEBPACK FOOTER //
// src/pages/insure/verify.vue